/*
 * 非左键点击不能拖拽滚动（避免右键点击后显示系统弹窗后滚动条不跟随鼠标移动，关闭弹窗后滚动条瞬间跳转）
*/
<template>
  <div ref="wrapper" :class="classes" @mouseenter="showBar" @mouseleave="hideBar">
    <div ref="slot" :class="containerClasses" @scroll="onScrollHandle">
      <div v-resize="handleResize">
        <slot></slot>
      </div>
    </div>
    <div ref="ybar" :class="[outerClasses, 'y']">
      <div
        class="scroll-bar-inner"
        :class="{move: move.yMouseDown}"
        :style="`height:${yBarHeight}px;opacity:${yBarOpacity};transform:translateY(${yInnerTop}px)`"
        @mousedown="yMouseDownHandle"
      ></div>
    </div>
    <div ref="xbar" :class="[outerClasses, 'x']">
      <div
        class="scroll-bar-inner"
        :class="{move: move.xMouseDown}"
        :style="`width:${xBarWidth}px;opacity:${xBarOpacity};transform:translateX(${xInnerLeft}px)`"
        @mousedown="xMouseDownHandle"
      ></div>
    </div>
  </div>
</template>

<script>
import * as constants from '../../utils/constants'
import { getScrollBarSize } from './util'
import resize from '../../directives/resize'

const prefixCls = `${constants.PREFIX_CLASS}scroll-bar`

export default {
  name: 'TScrollBar',
  directives: { resize },
  props: {
    autoHide: {
      type: Boolean,
      default: false
    },
    listenScrollBottom: {
      type: [Function, Boolean],
      default: false
    },
    scrollBottomHeight: {
      type: Number,
      default: 50
    },
    listenScrollRight: {
      type: [Function, Boolean],
      default: false
    },
    scrollRightWidth: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      yBarHeight: 0,
      yBarOpacity: this.autoHide ? 0 : 1,
      yInnerTop: 0,
      xBarWidth: 0,
      xBarOpacity: this.autoHide ? 0 : 1,
      xInnerLeft: 0,
      info: {
        // 刷新的时候才更新 减少读取 增加性能
        wrapperHeight: 0,
        wrapperWidth: 0,
        contentWidth: 0,
        contentHeight: 0,
        yBarHeight: 0,
        xBarWdith: 0
      },
      move: {
        yMouseDown: false,
        yMouseDownOffset: 0,
        xMouseDown: false,
        xMouseOffset: 0
      }
    }
  },
  computed: {
    classes() {
      return prefixCls
    },
    containerClasses() {
      return `${prefixCls}-container`
    },
    outerClasses() {
      return `${prefixCls}-outer`
    }
  },
  mounted() {
    // 屏蔽滚动条鼠标右键事件
    this.disabledBarRigthClickEvent()
    // 获取滚动条宽度，设置 container 偏移
    this.setContainerOffset()
    // 获取基本的宽高信息
    this.reGetInfo()
  },
  methods: {
    // 屏蔽滚动条鼠标右键事件
    disabledBarRigthClickEvent() {
      this.$refs.ybar.oncontextmenu = function(e) {
        return false
      }
      this.$refs.xbar.oncontextmenu = function(e) {
        return false
      }
    },
    // 获取该设备的默认滚动条宽度 依赖这个宽度把滚动条顶出去
    setContainerOffset() {
      let scrollBarWidth = getScrollBarSize()
      this.$refs.slot.style.marginRight = `-${scrollBarWidth}px`
      this.$refs.slot.style.marginBottom = `-${scrollBarWidth}px`
    },
    // 获取基本的宽高信息
    reGetInfo() {
      this.info.wrapperHeight = this.$refs.wrapper.clientHeight
      this.info.wrapperWidth = this.$refs.wrapper.clientWidth
      this.info.contentHeight = this.$refs.slot.children[0].clientHeight
      this.info.contentWidth = this.$refs.slot.children[0].children[0].clientWidth
      this.info.yBarHeight = this.$refs.ybar.clientHeight
      this.info.xBarWdith = this.$refs.xbar.clientWidth
      // y-bar
      if (this.info.contentHeight <= this.info.wrapperHeight + 1) {
        this.yBarHeight = 0
      } else {
        this.yBarHeight = (this.info.wrapperHeight / this.info.contentHeight) * this.info.yBarHeight
      }
      // x-bar
      if (this.info.contentWidth <= this.info.wrapperWidth + 1) {
        this.xBarWidth = 0
      } else {
        this.xBarWidth = (this.info.wrapperWidth / this.info.contentWidth) * this.info.xBarWdith
      }
    },
    // container 滚动事件
    onScrollHandle(e) {
      const slotScrollTop = this.$refs.slot.scrollTop
      const slotScrollLeft = this.$refs.slot.scrollLeft
      const yScrollPercent = slotScrollTop / this.info.contentHeight
      const xScrollPercent = slotScrollLeft / this.info.contentWidth
      this.yInnerTop = this.info.yBarHeight * yScrollPercent
      this.xInnerLeft = this.info.xBarWdith * xScrollPercent
      // 监听滚动到底部
      if (this.listenScrollBottom) {
        const bottomHeight =
          this.info.contentHeight - this.info.wrapperHeight - slotScrollTop
        if (bottomHeight <= this.scrollBottomHeight) {
          this.listenScrollBottom(bottomHeight)
        }
      }
      // 监听滚动到右侧（横向滚动）
      if (this.listenScrollRight) {
        const rightWidth =
          this.info.contentWidth - this.info.wrapperWidth - slotScrollLeft
        if (rightWidth <= this.scrollRightWidth) {
          this.listenScrollRight(rightWidth)
        }
      }
    },
    showBar() {
      this.yBarOpacity = 1
      this.xBarOpacity = 1
    },
    hideBar() {
      if (this.autoHide && !this.move.xMouseDown && !this.move.yMouseDown) {
        this.yBarOpacity = 0
        this.xBarOpacity = 0
      }
    },
    yMouseDownHandle(e) {
      const eventScreenY = e.screenY
      // y 轴滚动标记
      this.move.yMouseDown = true
      this.move.yMouseDownOffset = eventScreenY
      // 滚动事件
      const moveHandle = e => {
        // 非左键点击不能拖拽滚动
        if (e.which !== 1) {
          return false
        }
        e.preventDefault()
        // 计算出Y轴偏移和缩放比例 让content进行滚动
        const moveScreenY = e.screenY
        let offsetY = moveScreenY - this.move.yMouseDownOffset
        this.move.yMouseDownOffset = moveScreenY
        let scale = this.info.contentHeight / this.info.yBarHeight
        let contentOffset = offsetY * scale
        this.$refs.slot.scrollTop += contentOffset
      }
      const mouseupHandle = e => {
        // 清除监听 重设默认值
        // 自动隐藏
        document.removeEventListener('mousemove', moveHandle)
        this.move.yMouseDown = false
        this.move.yMouseDownOffset = 0
        document.removeEventListener('mouseup', mouseupHandle)
      }
      document.addEventListener('mousemove', moveHandle)
      document.addEventListener('mouseup', mouseupHandle)
    },
    xMouseDownHandle(e) {
      const eventScreenX = e.screenX
      this.move.xMouseDown = true
      this.move.xMouseDownOffset = eventScreenX
      const moveHandle = e => {
        // 非左键点击不能拖拽滚动
        if (e.which !== 1) {
          return false
        }
        // 计算出X轴偏移和缩放比例 让content进行滚动
        e.preventDefault()
        const moveScreenX = e.screenX
        let offsetX = moveScreenX - this.move.xMouseDownOffset
        this.move.xMouseDownOffset = moveScreenX
        let scale = this.info.contentWidth / this.info.xBarWdith
        let contentOffset = offsetX * scale
        this.$refs.slot.scrollLeft += contentOffset
      }
      const mouseupHandle = e => {
        // 清除监听 重设默认值
        // 自动隐藏
        document.removeEventListener('mousemove', moveHandle)
        this.move.xMouseDown = false
        this.move.xMouseDownOffset = 0
        document.removeEventListener('mouseup', mouseupHandle)
      }
      document.addEventListener('mousemove', moveHandle)
      document.addEventListener('mouseup', mouseupHandle)
    },
    handleResize() {
      console.log('resize')
      this.reGetInfo()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/scroll-bar/scroll-bar.vue